export const ariaLabelText = {
  drawerOpen: 'Открыть меню',
  drawerClose: 'Закрыть меню',
};

export const errorText = {
  gmapKeyNotFound: 'API Ключ не найден',
  gmapCoordinatesNotFound: 'Coordinate was not found. Pls check data-coordinates attribute',
};

export const message = {
  missingValue: {
    checkbox: 'Это поле обязательно.',
    radio: 'Пожалуйста, выберите значение.',
    select: 'Пожалуйста, выберите значение.',
    'select-multiple': 'Пожалуйста, выберите хотябы одно значение.',
    default: 'Пожалуйста, заполните это поле.',
  },
  patternMismatch: {
    email: 'Пожалуйста, введите верный email.',
    url: 'Пожалуйста, введите URL.',
    number: 'Please enter a number',
    color: 'Please match the following format: #rrggbb',
    date: 'Please use the YYYY-MM-DD format',
    time: 'Please use the 24-hour time format. Ex. 23:00',
    month: 'Please use the YYYY-MM format',
    default: 'Please match the requested format.',
  },
  outOfRange: {
    over: 'Please select a value that is no more than {max}.',
    under: 'Please select a value that is no less than {min}.',
  },
  wrongLength: {
    over: 'Please shorten this text to no more than {maxLength} characters. You are currently using {length} characters.',
    under: 'Поле должно быть заполнено на {minLength} символов или более. Сейчас - {length} символов.',
  },
};
